<!-- container-fluid -->
<section id="section-report" class="px-2 mt-lg-2">
  <div class="row">
    <div id="container-report" class="col-12 col-lg-12">
      <table class="page mt-1" id="preview-invoice"
        *ngFor=" let  invoiceModel of invoiceModels; trackBy: trackByInvoiceId" (mousedown)="onMouseDown($event)"
        (dragstart)="onDragStart($event)">
        <thead id="thead">
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{invoiceModel.invoiceId}}" class="head col-12 col-lg-12">
                  <!-- Logo -->
                  <img id="logo-{{invoiceModel.invoiceId}}" [src]="logoEnterprise" alt="" draggable="false">

                  <!--Nombre Empresa -->
                  <p id="nombre-empresa-{{invoiceModel.invoiceId}}">
                    {{invoiceModel.enterpriseName}}</p>

                  <!--Nit -->
                  <label id="t-nit-empresa-{{invoiceModel.invoiceId}}">{{'t-nit-empresa' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="nit-empresa-{{invoiceModel.invoiceId}}">
                    {{invoiceModel.enterpriseNit}}
                  </p>

                  <!-- Ciudad/Depto -->
                  <p id="ciudad-departamento-{{invoiceModel.invoiceId}}">
                    {{invoiceModel.departmentCityBranch}}</p>

                  <!-- Dirección -->
                  <label id="t-direccion-{{invoiceModel.invoiceId}}">{{'t-direccion' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="direccion-{{invoiceModel.invoiceId}}">
                    {{invoiceModel.addressBranch}}</p>

                  <!--Teléfono  -->
                  <label id="t-telefono-{{invoiceModel.invoiceId}}">{{'t-telefono' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="telefono-{{invoiceModel.invoiceId}}">
                    {{invoiceModel.phoneBranch}}</p>

                  <!--Resolución  -->
                  <label id="t-resolucion-{{invoiceModel.invoiceId}}">{{'t-resolucion' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="resolucion-{{invoiceModel.invoiceId}}">
                    {{invoiceModel.resolutionComplete}}</p>

                  <!-- Nombre Sucursal -->
                  <label id="t-sucursal-nombre-{{invoiceModel.invoiceId}}">{{'t-sucursal-nombre' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="sucursal-nombre-{{invoiceModel.invoiceId}}">
                    {{invoiceModel.branchName}}</p>

                  <!-- Correo Sucursal -->
                  <label id="t-sucursal-correo-{{invoiceModel.invoiceId}}">{{'t-sucursal-correo' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="sucursal-correo-{{invoiceModel.invoiceId}}">
                    {{invoiceModel.branchEmail}}</p>

                  <!--Cliente  -->
                  <label id="t-cliente-{{invoiceModel.invoiceId}}">{{'t-cliente' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="cliente-{{invoiceModel.invoiceId}}">
                    {{invoiceModel.clientNitName1}}
                  </p>

                  <p id="cliente2-{{invoiceModel.invoiceId}}">
                    {{invoiceModel.clientNitName2 }}
                  </p>

                  <!--C.Costos  -->
                  <label id="t-centro-costos-{{invoiceModel.invoiceId}}">{{'t-centro-costos' | formatLabelPipe
                    : elementsLabel}}</label>
                  <p id="centro-costos-{{invoiceModel.invoiceId}}" *ngIf="invoiceModel.costCenterId">
                    {{invoiceModel.costCenterCodeName}}
                  </p>

                  <!--Dirección factura Obra -->
                  <label id="t-direccion-factura-obra-{{invoiceModel.invoiceId}}">{{'t-direccion-factura-obra' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="direccion-factura-obra-{{invoiceModel.invoiceId}}">
                    {{invoiceModel.constructionSiteAddress}}</p>

                  <!--Dirección  -->
                  <label id="t-direccion-cliente-{{invoiceModel.invoiceId}}">{{'t-direccion-cliente' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="direccion-cliente-{{invoiceModel.invoiceId}}"> {{ invoiceModel.clientAddress}}</p>

                  <!--Teléfono  -->
                  <label id="t-telefono-cliente-{{invoiceModel.invoiceId}}">{{'t-telefono-cliente' |
                    formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="telefono-cliente-{{invoiceModel.invoiceId}}">{{invoiceModel.clientPhone}}</p>

                  <label id="t-titulo-factura-{{invoiceModel.invoiceId}}">{{'t-titulo-factura' | formatLabelPipe
                    : elementsLabel}}</label>

                  <!--consecutivo-factura  -->
                  <p id="consecutivo-factura-{{invoiceModel.invoiceId}}">{{invoiceModel.consecutive}}</p>

                  <!-- Forma de pago  -->
                  <label id="t-forma-pago-{{invoiceModel.invoiceId}}">{{'t-forma-pago' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="forma-pago-{{invoiceModel.invoiceId}}">
                    {{invoiceModel.invoiceOperation}}</p>

                  <!-- Medio de pago  -->
                  <label id="t-medio-pago-{{invoiceModel.invoiceId}}">{{'t-medio-pago' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="medio-pago-{{invoiceModel.invoiceId}}">
                    {{invoiceModel.conceptPaymentMethodName }}</p>

                  <!-- Fecha Emisión  -->
                  <label id="t-fecha-emision-{{invoiceModel.invoiceId}}">{{'t-fecha-emision' | formatLabelPipe
                    : elementsLabel}}</label>
                  <p id="fecha-emision-{{invoiceModel.invoiceId}}">
                    {{invoiceModel.dateInvoice | date: 'dd/MM/yyyy hh:mm:ss'}}</p>

                  <!-- Fecha Vencimiento  -->
                  <label id="t-fecha-vencimiento-{{invoiceModel.invoiceId}}">{{'t-fecha-vencimiento' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="fecha-vencimiento-{{invoiceModel.invoiceId}}">
                    {{invoiceModel.dateExpiration | date: 'dd/MM/yyyy'}}</p>

                  <!-- Periodo  -->
                  <label id="t-periodo-{{invoiceModel.invoiceId}}">{{'t-periodo' | formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="periodo-{{invoiceModel.invoiceId}}">{{invoiceModel.movementId ?
                    ((invoiceModel.rentalPeriodInitial | date: 'dd/MM/yyyy') + ' - ' +
                    (invoiceModel.rentalPeriodFinal | date: 'dd/MM/yyyy' )): '' }}</p>

                  <!-- Textos Factura -->
                  <p id="texto-factura1-{{invoiceModel.invoiceId}}" class="lh-1">{{invoiceModel.invoiceText1}}
                  </p>
                  <p id="texto-factura2-{{invoiceModel.invoiceId}}" class="lh-1">{{invoiceModel.invoiceText2}}
                  </p>
                  <p id="texto-factura3-{{invoiceModel.invoiceId}}" class="lh-1">{{invoiceModel.invoiceText3}}
                  </p>
                  <p id="texto-factura4-{{invoiceModel.invoiceId}}" class="lh-1">{{invoiceModel.invoiceText4}}
                  </p>
                  <p id="texto-factura5-{{invoiceModel.invoiceId}}" class="lh-1">{{invoiceModel.invoiceText5}}
                  </p>
                  <p id="texto-factura6-{{invoiceModel.invoiceId}}" class="lh-1">{{invoiceModel.invoiceText6}}
                  </p>

                  <!-- Orden de Compra  -->
                  <label id="t-orden-compra-{{invoiceModel.invoiceId}}">{{'t-orden-compra' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="orden-compra-{{invoiceModel.invoiceId}}">
                    {{invoiceModel.purchaseOrder}}</p>

                  <!-- Número Aprobación  -->
                  <label id="t-numero-aprobacion-{{invoiceModel.invoiceId}}">{{'t-numero-aprobacion' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="numero-aprobacion-{{invoiceModel.invoiceId}}">
                    {{invoiceModel.approvalNumber}}</p>

                  <!-- Remisión  -->
                  <label id="t-remision-{{invoiceModel.invoiceId}}">{{'t-remision' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="remision-{{invoiceModel.invoiceId}}">
                    {{invoiceModel.remission}}</p>

                  <!--Pagina Web  -->
                  <label id="t-pagina-web-{{invoiceModel.invoiceId}}">{{'t-pagina-web' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="pagina-web-{{invoiceModel.invoiceId}}">
                    {{invoiceModel.webPage}}
                  </p>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody id="tbody">
          <tr>
            <td>
              <div class="table-container">
                <p-table [value]="invoiceModel.invoiceDetails" dataKey="invoiceDetailId" [columns]="columns"
                  [reorderableColumns]="editFormat" (onColReorder)="onColumnReorder()"
                  [rowGroupMode]="formatModel.group ? 'subheader' : undefined"
                  [groupRowsBy]="formatModel.group ? 'conceptInvoicingId' : undefined"
                  [sortField]="formatModel.group ? 'conceptInvoicingId' : undefined" sortMode="single"
                  styleClass="p-datatable-sm" showGridlines>

                  <ng-template #header pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns; trackBy: trackByColumnField" pReorderableColumn
              [id]="'th-' + idMap[col.field].id + '-' + invoiceModel.invoiceId" (click)="clickTable($event)"
              [class]=" idMap[col.field].id">
              {{ col.header }}
            </th>
          </tr>
          </ng-template>
          <ng-template #body pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
            <tr [pReorderableRow]="index">
              <td *ngFor="let col of columns; trackBy: trackByColumnField"
                [id]="'td-' + idMap[col.field].id + '-' + rowData.id" (click)="clickTable($event)">
                {{rowData[col.field] | dynamicFormatPipe: idMap[col.field].type : idMap[col.field].printFormat}}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="groupfooter" let-detail>
            <tr *ngIf="formatModel.group" class="row-group-footer">
              <td [attr.colspan]="columns.length">
                <div class="summary-flex-container"
                  *ngIf="(groupDataMap() | groupInfoPipe: invoiceModel.invoiceId : detail.conceptInvoicingId) as info">

                  <!-- Reteica - Se oculta si la factura es tipo exportación y si no esta activa reteica -->
                  <ng-container *ngIf="reteIca && invoiceModel.bussinessDocumentsDianTypeId != typeDianInvoiceExport">
                    <p id="foot-group-reteica-{{invoiceModel.invoiceId}}" (click)="onClick()" class="group-reteica">
                      Rte.ICA:
                      <ng-container
                        *ngIf="labelPrintFormatMap['foot-group-reteica'] as  formatReteIca; else currencyFormatGroupReteIca">
                        {{ info.reteIca | dynamicFormatPipe:'decimal':formatReteIca }}
                      </ng-container>
                      <ng-template #currencyFormatGroupReteIca>
                        {{ info.reteIca | currency }}
                      </ng-template>
                  </ng-container>

                  <!-- Retefuente - Se oculta si la factura es tipo exportación y si no esta activa retefuente-->
                  <ng-container
                    *ngIf="retefuente && invoiceModel.bussinessDocumentsDianTypeId != typeDianInvoiceExport">
                    <p id="foot-group-retefuente-{{invoiceModel.invoiceId}}" (click)="onClick()"
                      class="group-retefuente">
                      Rte.Fte:
                      <ng-container
                        *ngIf="labelPrintFormatMap['foot-group-retefuente'] as  formatReteFte; else currencyFormatGroupReteFte">
                        {{ info.reteFuente | dynamicFormatPipe:'decimal':formatReteFte }}
                      </ng-container>
                      <ng-template #currencyFormatGroupReteFte>
                        {{ info.reteFuente | currency }}
                      </ng-template>
                    </p>
                  </ng-container>

                  <!-- Base IVA - Se oculta si la factura es tipo exportación -->
                  <p *ngIf="invoiceModel.bussinessDocumentsDianTypeId != typeDianInvoiceExport"
                    id="foot-group-baseIva-{{invoiceModel.invoiceId}}" (click)="onClick()" class="group-baseIva">
                    {{textBaseIva}}
                    <ng-container
                      *ngIf="labelPrintFormatMap['foot-group-baseIva'] as formatBaseIva; else currencyFormatGroupBaseIva">
                      {{ info.baseIva | dynamicFormatPipe:'decimal':formatBaseIva }}
                    </ng-container>
                    <ng-template #currencyFormatGroupBaseIva>
                      {{ info.baseIva | currency }}
                    </ng-template>
                  </p>

                  <!-- Tarifa IVA - Se oculta si la factura es tipo exportación -->
                  <ng-container *ngIf="invoiceModel.bussinessDocumentsDianTypeId != typeDianInvoiceExport">
                    <p id="foot-group-tarifaIva-{{invoiceModel.invoiceId}}" (click)="onClick()" class="group-tarifaIva">
                      {{textTarifaIva}}
                      <ng-container
                        *ngIf="labelPrintFormatMap['foot-group-tarifaIva'] as formatTarifaIva; else currencyFormatGroupTarifaIva">
                        {{ info.tarifaIva | dynamicFormatPipe:'decimal':formatTarifaIva }}
                      </ng-container>
                      <ng-template #currencyFormatGroupTarifaIva>
                        {{ info.tarifaIva | currency }}%
                      </ng-template>
                    </p>
                  </ng-container>

                  <!-- Concepto y valor total -->
                  <p id="foot-group-concept-{{invoiceModel.invoiceId}}" (click)="onClick()" class="group-concept">
                    {{ info.conceptName }}
                    <ng-container
                      *ngIf="labelPrintFormatMap['foot-group-concept'] as formatConcept; else currencyFormatGroupConcept">
                      {{ info.totalValue | dynamicFormatPipe:'decimal':formatConcept }}
                    </ng-container>
                    <ng-template #currencyFormatGroupConcept>
                      {{ info.totalValue | currency }}
                    </ng-template>
                  </p>
                </div>
              </td>
            </tr>
          </ng-template>
          </p-table>
          <div id="container-totals">
            <div id="totals">
              <div class="row d-flex justify-content-start totalRegContainer">
                <!-- Total registros -->
                <p id="foot-total-reg-{{invoiceModel.invoiceId}}" class="totalReg" (click)="onClick()">
                  Total Reg: {{totalRegDetail}}
                </p>
              </div>

              <!-- subtotal -->
              <div class="row d-flex justify-content-end">
                <label id="foot-t-subtotal-{{invoiceModel.invoiceId}}" for="" class="">{{'foot-t-subtotal' |
                  formatLabelPipe :
                  elementsLabel}}</label>

                <p id="foot-subtotal-espacio-{{invoiceModel.invoiceId}}">
                </p>

                <p id="foot-subtotal-{{invoiceModel.invoiceId}}" (click)="onClick()">
                  <ng-container
                    *ngIf="labelPrintFormatMap['foot-subtotal'] as formatSubtotal; else currencyFormatSubtotal">
                    {{ invoiceModel.subtotalValue | dynamicFormatPipe:'decimal':formatSubtotal }}
                  </ng-container>
                  <ng-template #currencyFormatSubtotal>
                    {{ invoiceModel.subtotalValue | currency }}
                  </ng-template>
                </p>
              </div>

              <!-- Descuento general -->
              <div class="row d-flex justify-content-end">
                <label id="foot-t-dcto-gral-{{invoiceModel.invoiceId}}" for="" class="">{{'foot-t-dcto-gral' |
                  formatLabelPipe :
                  elementsLabel}}</label>

                <p id="foot-dcto-gral-espacio-{{invoiceModel.invoiceId}}">
                </p>

                <p id="foot-dcto-gral-{{invoiceModel.invoiceId}}" (click)="onClick()">
                  <ng-container
                    *ngIf="labelPrintFormatMap['foot-dcto-gral'] as formatDctoGral; else currencyFormatDescuento">
                    {{ invoiceModel.discountValue | dynamicFormatPipe:'decimal':formatDctoGral }}
                  </ng-container>
                  <ng-template #currencyFormatDescuento>
                    {{ invoiceModel.discountValue | currency }}
                  </ng-template>
                </p>
              </div>

              <!-- Valor Iva **Nota: Muestro si el tipo Dian es diferente a Factura de exportación ** -->
              <div *ngIf="invoiceModel.bussinessDocumentsDianTypeId != typeDianInvoiceExport"
                class="row d-flex justify-content-end">
                <label id="foot-t-valor-iva-{{invoiceModel.invoiceId}}" for="" class="">{{'foot-t-valor-iva' |
                  formatLabelPipe :
                  elementsLabel}}</label>

                <p id="foot-valor-iva-espacio-{{invoiceModel.invoiceId}}">
                </p>

                <p id="foot-valor-iva-{{invoiceModel.invoiceId}}" (click)="onClick()">
                  <ng-container
                    *ngIf="labelPrintFormatMap['foot-valor-iva'] as formatValorIva; else currencyFormatValorIva">
                    {{ invoiceModel.ivaValue | dynamicFormatPipe:'decimal':formatValorIva }}
                  </ng-container>
                  <ng-template #currencyFormatValorIva>
                    {{ invoiceModel.ivaValue | currency }}
                  </ng-template>
                </p>
              </div>

              <!-- total -->
              <div class="row d-flex justify-content-end">
                <label id="foot-t-total-{{invoiceModel.invoiceId}}" for="" class="">{{'foot-t-total' | formatLabelPipe :
                  elementsLabel}}</label>

                <p id="foot-total-espacio-{{invoiceModel.invoiceId}}">
                </p>

                <p id="foot-total-{{invoiceModel.invoiceId}}" (click)="onClick()">
                  <ng-container *ngIf="labelPrintFormatMap['foot-total'] as formatTotal; else currencyFormatTotal">
                    {{ invoiceModel.totalValue | dynamicFormatPipe:'decimal':formatTotal }}
                  </ng-container>
                  <ng-template #currencyFormatTotal>
                    {{ invoiceModel.totalValue | currency }}
                  </ng-template>
                </p>
              </div>

              <!-- Valor ReteIva  **Nota: Muestro si reteIva es activo y si el tipo Dian es diferente a Factura de exportación ** -->
              <div *ngIf="reteIva && invoiceModel.bussinessDocumentsDianTypeId != typeDianInvoiceExport"
                class=" row d-flex justify-content-end">
                <label id="foot-t-valor-reteIva-{{invoiceModel.invoiceId}}" for="" class="">{{'foot-t-valor-reteIva'
                  | formatLabelPipe :
                  elementsLabel}}</label>

                <p id="foot-valor-reteIva-espacio-{{invoiceModel.invoiceId}}">
                </p>

                <p id="foot-valor-reteIva-{{invoiceModel.invoiceId}}" (click)="onClick()">
                  <ng-container
                    *ngIf="labelPrintFormatMap['foot-valor-reteIva'] as formatValorReteIva; else currencyFormatReteIva">
                    {{ invoiceModel.reteIvaValue | dynamicFormatPipe:'decimal':formatValorReteIva }}
                  </ng-container>
                  <ng-template #currencyFormatReteIva>
                    {{ invoiceModel.reteIvaValue | currency }}
                  </ng-template>
                </p>
              </div>

              <!-- Valor Retefuente **Nota: Muestro si retefuente es activo y si el tipo Dian es diferente a Factura de exportación** -->
              <div *ngIf="retefuente && invoiceModel.bussinessDocumentsDianTypeId != typeDianInvoiceExport"
                class="row d-flex justify-content-end">
                <label id="foot-t-valor-reteFte-{{invoiceModel.invoiceId}}" for="" class="">{{'foot-t-valor-reteFte'
                  | formatLabelPipe :
                  elementsLabel}}</label>

                <p id="foot-valor-reteFte-espacio-{{invoiceModel.invoiceId}}">
                </p>

                <p id="foot-valor-reteFte-{{invoiceModel.invoiceId}}" (click)="onClick()">
                  <ng-container
                    *ngIf="labelPrintFormatMap['foot-valor-reteFte'] as formatValorReteFte; else currencyFormatReteFte">
                    {{ invoiceModel.reteFuenteValue | dynamicFormatPipe:'decimal':formatValorReteFte }}
                  </ng-container>
                  <ng-template #currencyFormatReteFte>
                    {{ invoiceModel.reteFuenteValue | currency }}
                  </ng-template>
                </p>
              </div>

              <!-- Valor ReteIca **Nota: Muestro si reteIca es activo y si el tipo Dian es diferente a Factura de exportación ** -->
              <div *ngIf="reteIca && invoiceModel.bussinessDocumentsDianTypeId != typeDianInvoiceExport"
                class="row d-flex justify-content-end">
                <label id="foot-t-valor-reteIca-{{invoiceModel.invoiceId}}" for="" class="">{{'foot-t-valor-reteIca'
                  | formatLabelPipe :
                  elementsLabel}}</label>

                <p id="foot-valor-reteIca-espacio-{{invoiceModel.invoiceId}}">
                </p>

                <p id="foot-valor-reteIca-{{invoiceModel.invoiceId}}" (click)="onClick()">
                  <ng-container
                    *ngIf="labelPrintFormatMap['foot-valor-reteIca'] as formatValorReteIca; else currencyFormatReteIca">
                    {{ invoiceModel.reteIcaValue | dynamicFormatPipe:'decimal':formatValorReteIca }}
                  </ng-container>
                  <ng-template #currencyFormatReteIca>
                    {{ invoiceModel.reteIcaValue | currency }}
                  </ng-template>
                </p>
              </div>

              <!-- valor a pagar -->
              <div class="row d-flex justify-content-end">
                <label id="foot-t-valor-pagar-{{invoiceModel.invoiceId}}" for="" class="">{{'foot-t-valor-pagar'
                  | formatLabelPipe :
                  elementsLabel}}</label>

                <p id="foot-moneda-{{invoiceModel.invoiceId}}">
                  {{(invoiceModel.currencyCode)}}
                </p>

                <p id="foot-valor-pagar-{{invoiceModel.invoiceId}}" (click)="onClick()">
                  <ng-container
                    *ngIf="labelPrintFormatMap['foot-valor-pagar'] as formatValorPagar; else currencyFormatValorPagar">
                    {{ invoiceModel.valueToPay | dynamicFormatPipe:'decimal':formatValorPagar }}
                  </ng-container>
                  <ng-template #currencyFormatValorPagar>
                    {{ invoiceModel.valueToPay | currency }}
                  </ng-template>
                </p>
              </div>

              <!-- Total en letras -->
              <div class="row pt-1" *ngIf="invoiceModel.currencyId == currencyLocal">
                <p id="foot-totals-in-letters-{{invoiceModel.invoiceId}}" (click)="onClick()">
                  Valor en letras: {{invoiceModel.totalValueInLetters}}</p>
              </div>
            </div>

          </div>
    </div>
    <!-- Observación Factura -->
    <div id="foot-{{invoiceModel.invoiceId}}" class="foot container-observations">
      <label id="t-observación-factura-{{invoiceModel.invoiceId}}" class="lh-1"
        *ngIf="invoiceModel.observation">{{'t-observación-factura' |
        formatLabelPipe : elementsLabel}}</label>
      <p id="observación-factura-{{invoiceModel.invoiceId}}" class="lh-1" *ngIf="invoiceModel.observation">
        {{invoiceModel.observation}}</p>

      <!-- Observaciones Empresa -->
      <p id="observacion1-{{invoiceModel.invoiceId}}" class="lh-1">
        {{invoiceModel.observationInvoice1}}</p>
      <p id="observacion2-{{invoiceModel.invoiceId}}" class="lh-1">
        {{invoiceModel.observationInvoice2}}</p>
      <p id="observacion3-{{invoiceModel.invoiceId}}" class="lh-1">
        {{invoiceModel.observationInvoice3}}</p>

      <!-- ProntoPago -->
      <!-- Si hay pronto pago lo muestro -->
      <p *ngIf="invoiceModel.promptPaymentText" id="pronto-pago-{{invoiceModel.invoiceId}}" class="lh-1">
        {{invoiceModel.promptPaymentText}}</p>

      <!-- Firma Emisor-->
      <img id="firma-{{invoiceModel.invoiceId}}" [src]="signatureEnterprise" alt="" draggable="false">
      <p id="linea-firma-emisor-{{invoiceModel.invoiceId}}" class="write-line"></p>
      <label id="t-firma-emisor-{{invoiceModel.invoiceId}}">{{'t-firma-emisor' | formatLabelPipe :
        elementsLabel}}</label>

      <!-- Firma receptor-->
      <p id="linea-firma-receptor-{{invoiceModel.invoiceId}}" class="write-line"></p>
      <label id="t-linea-receptor-{{invoiceModel.invoiceId}}">{{'t-linea-receptor' | formatLabelPipe :
        elementsLabel}}</label>

      <!-- QR -->
      @if (invoiceModel?.cufe == null && editFormat) {
      <!-- Muestro QR con datos de prueba para configurar formato -->
      <qrcode *ngIf="electronicInvoice" name="qr" [qrdata]="cufeTemp" [allowEmptyString]="true" [cssClass]="'center'"
        [colorDark]="'#000000ff'" [colorLight]="'#ffffffff'" [elementType]="'canvas'" [errorCorrectionLevel]="'L'"
        [margin]="4" [scale]="1" [title]="'qr-' + invoiceModel?.invoiceId" [width]="150"></qrcode>
      } @else {
      <qrcode *ngIf="invoiceModel?.cufe" name="qr" [qrdata]="invoiceModel?.qrData || ''" [allowEmptyString]="true"
        [cssClass]="'center'" [colorDark]="'#000000ff'" [colorLight]="'#ffffffff'" [elementType]="'canvas'"
        [errorCorrectionLevel]="'L'" [margin]="4" [scale]="1" [title]="'qr-' + invoiceModel?.invoiceId" [width]="150">
      </qrcode>
      }

      <!-- Fecha Validación Dian  -->
      <label *ngIf="electronicInvoice" id="t-fecha-validacion-{{invoiceModel.invoiceId}}">{{'t-fecha-validacion' |
        formatLabelPipe
        : elementsLabel}}</label>

      <p *ngIf="electronicInvoice" id="fecha-validacion-{{invoiceModel.invoiceId}}">
        {{invoiceModel.dateValidationDian == null && editFormat ? "01/01/0001 00:00:00" :
        invoiceModel.dateValidationDian | date:'dd/MM/yyyy hh:mm:ss'}}</p>

      <!-- Cufe  -->
      <label *ngIf="electronicInvoice" id="t-cufe-{{invoiceModel.invoiceId}}" for="">{{'t-cufe' | formatLabelPipe :
        elementsLabel}}</label>
      <p *ngIf="electronicInvoice" id="cufe-{{invoiceModel.invoiceId}}">
        {{invoiceModel.cufe == null && editFormat ? "CUFE DE PRUEBA para la configuración de formatos" :
        invoiceModel.cufe }}
      </p>
    </div>
    </td>
    </tr>
    </tbody>
    <tfoot id="tfoot">
      <tr>
        <td colspan="1">
          <div [ngClass]="paperSize == paperSizeFormat ? 'footer' : ''"
            class="d-flex flex-column justify-content-center">
            <p class="texto-factura-footer mx-1 lh-1">{{invoiceModel.observationFooter}} </p>
            <div class="copyright d-flex justify-content-center mt-2">
              <p class="mt-2">Factura generada con el Software Cervino de Altos Software SAS. Nit.811.022.121-1.
                www.altos-soft.com</p>
              <!-- Proveedor Tecnológico -->
              <label *ngIf="electronicInvoice" class="ms-1"> - P.T.:</label>
              <p *ngIf="electronicInvoice"> {{invoiceModel.tecnologyProvider }}</p>
            </div>
            <!-- Trafico Factura -->
            <p class="footer-text align-center">{{invoiceTraffic == '' ? 'ORIGINAL CLIENTE' : invoiceTraffic}} </p>
          </div>
          <div class="information-print d-flex">
            <label class="fw-bold pe-2">Fecha: </label>
            <p class="pe-4">{{ dateNow | date : "dd/MM/yyyy" }}</p>
            <label class="fw-bold pe-2">Hora: </label>
            <p class="pe-4">{{ dateNow | date : "hh:mm:ss a" }}</p>
            <label class="fw-bold pe-2">Usuario: </label>
            <p class="pe-4">{{ userAuthenticated }}</p>
          </div>
        </td>
      </tr>
    </tfoot>
    </table>
  </div>
  </div>
</section>